// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import LocalStore from './localstore'
import i18n from './localization'
import axios from 'axios'
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import Vue2TouchEvents from 'vue2-touch-events'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import App from './App'
import router from './router'
import store from './store'
import VueQrcodeReader from 'vue-qrcode-reader'
import { Datetime } from 'vue-datetime'
import SortedTablePlugin from 'vue-sorted-table'
import VueGrid from '@liqueflies/vue-flex-grid'
import { Settings } from 'luxon'
import './assets/scss/default.scss'
import { RecycleScroller, DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(VueRouter)
Vue.config.productionTip = true
Vue.config.devtools = false
Vue.use(Loading)
Vue.use(VueAxios, axios)
Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  swipeTolerance: 100,
  longTapTimeInterval: 400
})

let lang = store.getters.lang
if (lang === 'en') lang = 'en-gb'
Settings.defaultLocale = lang

const moment = require('moment')
require('moment/locale/' + lang)

Vue.use(require('vue-moment'), { moment })
Vue.use(VueQrcodeReader)
// Vue.use(LiquorTree)
Vue.component('RecycleScroller', RecycleScroller)
Vue.component('DynamicScroller', DynamicScroller)
Vue.component('DynamicScrollerItem', DynamicScrollerItem)
Vue.use(SortedTablePlugin)
Vue.use(VueGrid)
Vue.use(Datetime)
Vue.filter('truncate', (text, stop, clamp) => text.slice(0, stop) + (stop < text.length ? clamp || '...' : ''))
/* eslint-disable no-new */
new Vue({
  el: '#app',
  ls: LocalStore,
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js